export default {
    congratulations: 'Congratulations',
    you_get_a_free_spin: 'You get a free spin',
    spin_now: 'Spin now',
};
